import config from '@/config/config';

function customFetch(url: string | URL, init?: RequestInit): Promise<Response> {
  init = init || {};
  init.headers = (init.headers || {}) as Record<string, string>;
  const token = sessionStorage?.getItem('access_token') || localStorage?.getItem('access_token');
  (init.headers as Record<string, string>).Authorization = `Bearer ${token || ''}`;
  (init.headers as Record<string, string>)['X-UI-AppName'] = config.ui_app_name;
  return fetch(url, init);
}

export default {
  url: config.unleash_url,
  appName: config.unleash_app_name,
  clientKey: config.unleash_client_key,
  environment: config.server_env === 'production' ? 'production' : 'development',
  fetch: customFetch,
  disableMetrics: true,
  usePOSTrequests: true
};
